import { render, staticRenderFns } from "./chatBox.vue?vue&type=template&id=08b7d37e&scoped=true&"
import script from "./chatBox.vue?vue&type=script&lang=js&"
export * from "./chatBox.vue?vue&type=script&lang=js&"
import style0 from "./chatBox.vue?vue&type=style&index=0&id=08b7d37e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b7d37e",
  null
  
)

export default component.exports